<template>
    <section class="m-apply-list-part">
        <div v-for="(item,index) in ListArr" :key="item.id" class="m-list-blk">
            <h2 class="m-apply-list-title">
                <span class="u-apply-list-num">{{index+1}}</span>
                {{item.hy_name}}
            </h2>
            <div class="m-apply-list-box">
                <div class="u-apply-list-name">团队成员：</div>
                <div class="m-apply-list-des">
                    <p>{{item.chair_name}}（首席）</p>
                    <p>{{item.team_name}}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "List",
    props: {
        ListArr: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            msg: "list"
        };
    }
};
</script>
